import { ref } from 'vue';

const STORAGE_KEY = 'formplat.theme';
type Theme = 'light' | 'dark';

function initial(): Theme {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export const theme = ref<Theme>(initial());

function apply(): void {
  document.documentElement.classList.toggle('dark', theme.value === 'dark');
}

export function toggleTheme(): void {
  theme.value = theme.value === 'dark' ? 'light' : 'dark';
  localStorage.setItem(STORAGE_KEY, theme.value);
  apply();
}

apply();
